import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import Logo from "../../assets/images/touramp.png";

import Menu from "../../assets/icons/menu.svg";
import Down from "../../assets/icons/down.svg";
import Location from "../../assets/icons/location.svg";
import Person from "../../assets/icons/person.svg";
import { ReactComponent as PersonRound } from "../../assets/icons/person-rounded.svg";

import RestaurantList from "./components/RestaurantList";
import SetLocationModal from "./components/SetLocationModal";
import { IRootState } from "../..";
import CartIcon from "./components/CartIcon";

import SideNavigation from "./components/SideNavigation";

const Header = () => {
  const address = useSelector((state: IRootState) => state.profile.value);
  const user = useSelector((state: IRootState) => state.user.value);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loggedIn } = user;
  const [isOpen, setIsOpen] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [isLocationActive, setIsLocationActive] = useState(false);

  useEffect(() => {
    if (address.home_address === "") {
      setIsLocationActive(true);
    }
  }, [address.home_address]);
  return (
    <div>
      {isActive && <SideNavigation onClose={() => setIsActive(false)} />}
      {isLocationActive && (
        <SetLocationModal onClose={() => setIsLocationActive(false)} />
      )}
      <div className="flex flex-col gap-4 md:flex-row fixed top-0 text-black justify-between items-center py-3 px-4 md:px-16 lg:px-20 w-full z-[10] bg-white">
        <div className="flex justify-between items-center w-full border-b md:border-b-0 pb-2 md:pb-0">
          <Link to="/home">
            <img src={Logo} className="w-28" alt="" />
          </Link>
          <div className="flex items-center text-sm gap-7 md:hidden">
            <CartIcon />
            {loggedIn && (
              <div
                className="cursor-pointer"
                onClick={() => navigate("/settings/profile")}
              >
                <PersonRound />
              </div>
            )}
            <img
              src={Menu}
              alt=""
              className="cursor-pointer"
              onClick={() => setIsActive(true)}
            />
          </div>
          <div className="md:flex items-center text-sm gap-7 hidden">
            <div className="">
              <div
                className="flex relative items-center gap-5 cursor-pointer"
                onMouseLeave={() => setIsOpen(false)}
                onMouseEnter={() => setIsOpen(true)}
              >
                <div className="">Establishment</div>
                <img src={Down} alt="" />
              </div>
              {isOpen && (
                <div
                  className="absolute top-10 z[10] bg-white flex gap-8 p-5 pt-10 items-start"
                  onMouseLeave={() => setIsOpen(false)}
                  onMouseEnter={() => setIsOpen(true)}
                >
                  <div className="whitespace-nowrap font-semibold text-sm">
                    Our Establishment
                  </div>
                  <RestaurantList />
                </div>
              )}
            </div>
            <div
              className="flex items-center gap-3 cursor-pointer"
              onClick={() => setIsLocationActive(true)}
            >
              <img src={Location} alt="" />
              <div className="pr-4 whitespace-nowrap">
                {address.home_address || "Add Address"}
              </div>
              <img src={Down} alt="" />
            </div>
            {loggedIn ? (
              <div
                className="cursor-pointer"
                onClick={() => navigate("/settings/profile")}
              >
                <PersonRound />
              </div>
            ) : (
              <div
                className="flex items-center gap-3 cursor-pointer"
                onClick={() => navigate("/login")}
              >
                <img src={Person} alt="" />
                <div className="font-medium whitespace-nowrap">
                  SIGN IN/SIGN UP
                </div>
              </div>
            )}
            <CartIcon />
          </div>
        </div>
        <div className="block md:hidden w-full">
          <div
            className="flex items-center justify-between cursor-pointer"
            onClick={() => setIsLocationActive(true)}
          >
            <img src={Location} alt="" />
            <div className="pr-4">{address.home_address || "Add Address"}</div>
            <img src={Down} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
